import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ApiFormWrapper } from "@madmedical/form";
import { preOpQuestions } from "@madmedical/medical";
import { adaptPatient, usePatient, useRouteNavigate } from "@madmedical/user";
import { useState } from "react";
import { CurrentPatientProvider, PreOpFormExit, PreOpFormPersonalData, PreOpFormStatement, PreOpFormSurvey1, PreOpFormSurvey2, PreOpFormSurvey3, PreOpFormWelcome, Spinner, } from "@madmedical/ui";
import { invariant } from "@madmedical/utils";
import { useSubmitQuestionnaireMutation } from "../api";
var Step;
(function (Step) {
    Step[Step["Welcome"] = 0] = "Welcome";
    Step[Step["PersonalData"] = 1] = "PersonalData";
    Step[Step["Survey1"] = 2] = "Survey1";
    Step[Step["Survey2"] = 3] = "Survey2";
    Step[Step["Survey3"] = 4] = "Survey3";
    Step[Step["Statement"] = 5] = "Statement";
    Step[Step["Exit"] = 6] = "Exit";
})(Step || (Step = {}));
const PreOpForm = () => {
    const { patientId, patient, isLoading: isPatientLoading, } = usePatient();
    const [submit] = useSubmitQuestionnaireMutation();
    const [step, setStep] = useState(Step.Welcome);
    const navigate = useRouteNavigate();
    const handleStep = (step) => () => {
        setStep(step);
    };
    const handleSuccess = () => {
        setStep(Step.Exit);
    };
    const handleExit = () => {
        navigate("dashboard", {});
    };
    if (isPatientLoading) {
        return _jsx(Spinner, {});
    }
    invariant(patient);
    return (_jsx(CurrentPatientProvider, Object.assign({ value: { patient: adaptPatient(patient) } }, { children: _jsx(ApiFormWrapper, Object.assign({ defaultValues: {
                patientId,
                questions: preOpQuestions,
                answers: Object.keys(preOpQuestions).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {}),
            }, mutation: submit, onSuccess: handleSuccess }, { children: ({ submitForm }) => (_jsxs(_Fragment, { children: [step === Step.Welcome && (_jsx(PreOpFormWelcome, { onNextPress: handleStep(Step.PersonalData) })), step === Step.PersonalData && (_jsx(PreOpFormPersonalData, { onPreviousPress: handleStep(Step.Welcome), onNextPress: handleStep(Step.Survey1) })), step === Step.Survey1 && (_jsx(PreOpFormSurvey1, { onPreviousPress: handleStep(Step.PersonalData), onNextPress: handleStep(Step.Survey2) })), step === Step.Survey2 && (_jsx(PreOpFormSurvey2, { onPreviousPress: handleStep(Step.Survey1), onNextPress: handleStep(Step.Survey3) })), step === Step.Survey3 && (_jsx(PreOpFormSurvey3, { onPreviousPress: handleStep(Step.Survey2), onNextPress: handleStep(Step.Statement) })), step === Step.Statement && (_jsx(PreOpFormStatement, { onPreviousPress: handleStep(Step.Survey3), onNextPress: submitForm })), step === Step.Exit && (_jsx(PreOpFormExit, { onNextPress: handleExit }))] })) })) })));
};
export default PreOpForm;
